<template>
	<!-- 通用头部 -->
	<div class="head-banner">
		<img v-if="headImg" class="w100" :src="headImg.value" alt="">
		<div class="right-btns">
			<!-- <a v-if="isTheEighth" class="btn" href="http://manage.xuesheng.ouchn.cn/" target="_blank">上报材料</a> -->
			<div class="btn wqhg-btn" v-if="historyInfo && historyInfo.list.total>0" 
				@mousemove="historyPopFn(true)"  @mouseleave="historyPopFn(false)">往期回顾
				<div class="pop" v-show="historyPopShow">
					<span v-for="(item,index) in historyInfo.list.list" :key="item.id" @click="goUrlOut(item.link)">{{item.title}}</span>
				</div>
			</div>
			<a class="btn" href="https://cy.ncss.cn/" target="_blank">报名参赛</a>
			<a class="btn" href="javascript:;" @click="goUrl({ name:'pageDetail2', query:{ code:'cjwt'}})">常见问题</a>
		</div>
	</div>
</template>

<script>
var historyPopTimer = null
export default {
	data () {
		return {
			headImg:null,
			historyInfo:null,
			historyPopShow:false
		}
	},

	computed:{
		isTheEighth(){
			return this.$store.state.isTheEighth
		}
	},
	
	mounted(){
		this.getBanner('headImg',1).then((list)=>{
			this.headImg = list[0]
		})
		
		this.getHistoryList()
	},
	 
	methods:{
		//往期回顾列表
		getHistoryList(){
			this.$axios({
				url:'/index.php?s=common&c=api&m=getReviewList',
				success:(res)=>{
					this.historyInfo =res.data
				}
			})
		},
		historyPopFn(isShow){
			clearTimeout(historyPopTimer)
			if(!isShow){
				historyPopTimer = setTimeout(()=>{
					this.historyPopShow = isShow
				},500)
			}else{
				this.historyPopShow = isShow
			}
			
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '~@/assets/css/common.less';
.head-banner{
	position:relative; font-size:0; line-height: 0;
	.right-btns{
		position:absolute; right:30px; top:20px;
		.btn{ 
			display:inline-block;font-size:24px; color:#fff; height:40px; line-height:40px;  margin-left:25px; padding-left:25px; position:relative;
			
		}
		.btn::after{ content:''; display:inline-block; height:16px; width:1px; background:#fff; position:absolute; left:0; top:12px;}
		.btn:first-child::after{display:none;}
		.btn:hover{color:#e83d27;}
		
		.wqhg-btn{
			cursor: default;
			.pop{
				position:absolute; width:150px; top:50px; left:50%; margin-left:-67px; background:#fff; border-radius:6px; padding:10px; text-align: center; 
				&::before{ content:''; width:0px; height:0px; overflow:hidden; font-size:0px; display:inline-block; border-style:solid; border-width:0 8px 10px 8px; border-color: transparent transparent #ffffff transparent; position:absolute; top:-10px; left:50%; margin-left:-8px;}
				span{font-size:14px; color:#2A82EF; line-height:28px; display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; cursor: pointer;}
				span:hover{text-decoration: underline;}
			}
			&:hover{
				color:#fff;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue